import VideoGrid from "@/components/editor/shared/media/video-grid/video-grid-component";
import Benefits from "@/components/editor/shared/sections/benefits/benefits-component";
import RelatedEventsSection from "@/components/editor/themes/hazel/blocks/sections/related-events";

import BoothCard from "./blocks/expo/booth-card/booth-card-component";
import Booths from "./blocks/expo/booths-component";
import SyncedBooths from "./blocks/expo/synced-booths-component";
import HeaderOption1 from "./blocks/headers/header-option-1/header-option-1-component";
import HeaderOption2 from "./blocks/headers/header-option-2/header-option-2-component";
import HeaderOption3 from "./blocks/headers/header-option-3/header-option-3-component";
import VideoWithParagraph from "./blocks/media/video-with-paragraph/video-with-paragraph-component";
import VideoWithTitle from "./blocks/media/video-with-title/video-with-title-component";
import StandaloneNavigation from "./blocks/navigations/standalone-navigation/standalone-navigation-component";
import DefaultSchedule from "./blocks/schedules/default-schedule/default-schedule-component";
import SyncedDefaultSchedule from "./blocks/schedules/default-schedule/synced-default-schedule-component";
import AboutDetails from "./blocks/sections/about-details/about-details-component";
import BenefitCard from "./blocks/sections/benefits/benefit-card/benefit-card-component";
import Divider from "./blocks/sections/divider/divider-component";
import DividerPicture from "./blocks/sections/divider-picture/divider-picture-component";
import Gallery from "./blocks/sections/gallery";
import ParagraphPicture from "./blocks/sections/paragraph-picture/paragraph-picture-component";
import ParagraphPictureOption2 from "./blocks/sections/paragraph-picture-option-2/paragraph-picture-option-2-component";
import RichTextSection from "./blocks/sections/rich-text-section/rich-text-section-component";
import SpeakerCard from "./blocks/speakers/speaker-card/speaker-card-component";
import SyncedSpeakerCard from "./blocks/speakers/speaker-card/synced-speaker-card-component";
import Speakers from "./blocks/speakers/speakers-component";
import SyncedSpeakers from "./blocks/speakers/synced-speakers-component";
import SponsorCard from "./blocks/sponsors/sponsor-card/sponsor-card-component";
import Sponsors from "./blocks/sponsors/sponsors-component";
import SyncedSponsors from "./blocks/sponsors/synced-sponsors-component";
import ParagraphItem from "./shared/paragraph-item-component";

const blocks = {
  AboutDetails,
  BenefitCard,
  Benefits,
  BoothCard,
  Booths,
  DefaultSchedule,
  Divider,
  DividerPicture,
  Gallery,
  HeaderOption1,
  HeaderOption2,
  HeaderOption3,
  ParagraphItem,
  ParagraphPicture,
  ParagraphPictureOption2,
  RelatedEventsSection,
  RichTextSection,
  SpeakerCard,
  Speakers,
  SponsorCard,
  Sponsors,
  StandaloneNavigation,
  SyncedBooths,
  SyncedDefaultSchedule,
  SyncedSpeakerCard,
  SyncedSpeakers,
  SyncedSponsors,
  VideoGrid,
  VideoWithParagraph,
  VideoWithTitle,
};

export default blocks;
